"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Launcher;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _LauncherModule = _interopRequireDefault(require("./Launcher.module.scss"));

var _progressBars = require("../../progressBars");

var _inputElements = require("../../inputElements");

var _common = require("../../common");

var _windows = require("../../windows");

var _Launcher = _interopRequireDefault(require("./Launcher.i18n"));

var _EServerPopulationGrade = _interopRequireDefault(require("./EServerPopulationGrade"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var WEBSITE_URL = "https://fhxrestoration.com";
var REGISTRATION_URL = "https://fhxrestoration.com/register";
var MANAGEMENT_URL = "https://fhxrestoration.com/team";
var ELauncherPage;

(function (ELauncherPage) {
  ELauncherPage["LOADING"] = "LOADING";
  ELauncherPage["LOGIN"] = "LOGIN";
  ELauncherPage["SERVER_SELECT"] = "SERVER_SELECT";
})(ELauncherPage || (ELauncherPage = {}));

function Launcher(_ref) {
  var _ref$patchNotes = _ref.patchNotes,
      patchNotes = _ref$patchNotes === void 0 ? "" : _ref$patchNotes,
      _ref$serverList = _ref.serverList,
      serverList = _ref$serverList === void 0 ? [] : _ref$serverList,
      onSelectServer = _ref.onSelectServer,
      _ref$websiteUrl = _ref.websiteUrl,
      websiteUrl = _ref$websiteUrl === void 0 ? WEBSITE_URL : _ref$websiteUrl,
      _ref$registrationUrl = _ref.registrationUrl,
      registrationUrl = _ref$registrationUrl === void 0 ? REGISTRATION_URL : _ref$registrationUrl,
      _ref$managementUrl = _ref.managementUrl,
      managementUrl = _ref$managementUrl === void 0 ? MANAGEMENT_URL : _ref$managementUrl,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var _useState = (0, _react.useState)(ELauncherPage.LOADING),
      _useState2 = _slicedToArray(_useState, 2),
      currentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedServer = _useState4[0],
      setSelectedServer = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isModalVislbe = _useState6[0],
      setIsModalVisible = _useState6[1];

  var _useState7 = (0, _react.useState)(""),
      _useState8 = _slicedToArray(_useState7, 2),
      modalContent = _useState8[0],
      setModalContent = _useState8[1];

  var _useState9 = (0, _react.useState)("myUsername"),
      _useState10 = _slicedToArray(_useState9, 2),
      username = _useState10[0],
      setUsername = _useState10[1];

  var _useState11 = (0, _react.useState)("password"),
      _useState12 = _slicedToArray(_useState11, 2),
      password = _useState12[0],
      setPassword = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isLogginIn = _useState14[0],
      setIsLogginIn = _useState14[1];

  var handleOnClickLogin = (0, _react.useCallback)(function () {
    setIsLogginIn(true);
    setTimeout(function () {
      setIsLogginIn(false);

      if (username !== "myUsername" || password !== "password") {
        setModalContent(formatMessage(_Launcher.default.invalidUsernameOrPassword));
        setIsModalVisible(true);
      } else {
        setCurrentPage(ELauncherPage.SERVER_SELECT); // TODO: perform login
      }
    }, 1000);
  }, [username, password, formatMessage]);
  var handleOnClickBack = (0, _react.useCallback)(function () {
    setCurrentPage(ELauncherPage.LOGIN);
    setSelectedServer(undefined);
  }, []);
  var handleOnClickFilechk = (0, _react.useCallback)(function () {
    setCurrentPage(ELauncherPage.LOADING);
  }, []);
  var handleOnClickSelectServer = (0, _react.useCallback)(function () {
    if (!selectedServer) {
      setModalContent(formatMessage(_Launcher.default.noServerSelected));
      setIsModalVisible(true);
    } else if (!selectedServer.isOnline) {
      setModalContent(formatMessage(_Launcher.default.thisServerIsOffline));
      setIsModalVisible(true);
    } else {
      setModalContent("TODO: This is not yet possible :)");
      setIsModalVisible(true);
    }

    if (onSelectServer) onSelectServer();
  }, [formatMessage, onSelectServer, selectedServer]);
  (0, _react.useEffect)(function () {
    // TODO: do a real loading of ressources ?
    // TODO clearTimeout
    if (currentPage === ELauncherPage.LOADING) {
      setTimeout(function () {
        setCurrentPage(ELauncherPage.LOGIN);
      }, 1200);
    }
  }, [currentPage]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isModalVislbe && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_common.Modal, null, /*#__PURE__*/_react.default.createElement(_windows.PromptWindow, {
    onSubmit: function onSubmit() {
      return setIsModalVisible(false);
    }
  }, modalContent))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LauncherModule.default.launcher, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.closeBtn
  }), currentPage !== ELauncherPage.SERVER_SELECT && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LauncherModule.default.subHeader, _LauncherModule.default.notices)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LauncherModule.default.content, _LauncherModule.default.notices)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.patchNotes
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.title
  }, formatMessage(_Launcher.default.patchnotes)), patchNotes))), currentPage === ELauncherPage.SERVER_SELECT && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LauncherModule.default.subHeader, _LauncherModule.default.serverList)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_LauncherModule.default.content, _LauncherModule.default.serverList)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.serverListTable
  }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("tbody", null, serverList.map(function (server) {
    var id = server.id,
        name = server.name,
        isOnline = server.isOnline,
        populationGrade = server.populationGrade;
    return /*#__PURE__*/_react.default.createElement("tr", {
      id: id.toString(),
      className: (0, _classnames.default)(id === (selectedServer === null || selectedServer === void 0 ? void 0 : selectedServer.id) && _LauncherModule.default.selected),
      onClick: function onClick() {
        return setSelectedServer(server);
      }
    }, /*#__PURE__*/_react.default.createElement("td", null, name), /*#__PURE__*/_react.default.createElement("td", null, isOnline && /*#__PURE__*/_react.default.createElement("div", {
      className: _LauncherModule.default.online
    }, formatMessage(_Launcher.default.online)), !isOnline && /*#__PURE__*/_react.default.createElement("div", {
      className: _LauncherModule.default.offline
    }, formatMessage(_Launcher.default.offline))), /*#__PURE__*/_react.default.createElement("td", null, populationGrade === _EServerPopulationGrade.default.FULL && formatMessage(_Launcher.default["serverPopulationGrade-FULL"]), populationGrade === _EServerPopulationGrade.default.HIGH && formatMessage(_Launcher.default["serverPopulationGrade-HIGH"]), populationGrade === _EServerPopulationGrade.default.MEDIUM && formatMessage(_Launcher.default["serverPopulationGrade-MEDIUM"]), populationGrade === _EServerPopulationGrade.default.LOW && formatMessage(_Launcher.default["serverPopulationGrade-LOW"])));
  })))))), currentPage === ELauncherPage.LOGIN && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.userInputs
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    type: "text",
    className: _LauncherModule.default.id,
    value: username,
    placeholder: "Username"
    /* TODO: i18n */
    ,
    onChange: function onChange(event) {
      return setUsername(event.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Input, {
    type: "password",
    className: _LauncherModule.default.pass,
    value: password,
    placeholder: "Password"
    /* TODO: i18n */
    ,
    onChange: function onChange(event) {
      return setPassword(event.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.buttonsFooter
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LAUNCHER_FILECHK,
    className: _LauncherModule.default.btnFilechk,
    onClick: handleOnClickFilechk
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LAUNCHER_WEBSITE,
    className: _LauncherModule.default.btnWebsite,
    onClick: function onClick() {
      window.open(websiteUrl, "_blank");
    }
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LAUNCHER_REGISTRATION,
    className: _LauncherModule.default.btnRegistration,
    onClick: function onClick() {
      window.open(registrationUrl, "_blank");
    }
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LAUNCHER_MANAGEMENT,
    className: _LauncherModule.default.btnManagement,
    onClick: function onClick() {
      window.open(managementUrl, "_blank");
    }
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LAUNCHER_LOGIN,
    className: _LauncherModule.default.btnLogin,
    onClick: handleOnClickLogin
  }))), currentPage === ELauncherPage.SERVER_SELECT && /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.buttonsFooter
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LAUNCHER_BACK,
    className: _LauncherModule.default.btnBack,
    onClick: handleOnClickBack
  }), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.LAUNCHER_LOGIN,
    className: _LauncherModule.default.btnSelectServer,
    onClick: handleOnClickSelectServer
  })), currentPage === ELauncherPage.LOADING && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.loadingText
  }, formatMessage(_Launcher.default.checkingForUpdates)), /*#__PURE__*/_react.default.createElement(_progressBars.ProgressBarAnimated, {
    type: "secondary",
    interval: 5,
    filledPerc: 100,
    className: _LauncherModule.default.progressBar
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.logo
  }), isLogginIn && /*#__PURE__*/_react.default.createElement("div", {
    className: _LauncherModule.default.loginOverlay
  }, /*#__PURE__*/_react.default.createElement(_common.Spinner, {
    width: 100,
    duration: 0.5,
    className: _LauncherModule.default.loadingSpinner
  }))));
}